import { render } from "./CollectionDetailedSearchDoctoralDissertations.vue?vue&type=template&id=050a91c8&scoped=true&ts=true"
import script from "./CollectionDetailedSearchDoctoralDissertations.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchDoctoralDissertations.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchDoctoralDissertations.vue?vue&type=style&index=0&id=050a91c8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050a91c8"]])

export default __exports__